var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketStudioLite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pocket_studio_lite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pocket_studio_lite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-256",
    transform: "translate(13.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 0.86,
    x2: 332,
    y2: 0.14,
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5,
    y1: 0.5,
    x2: 331.5,
    y2: 0.5,
    id: "Stroke-2",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    y1: 331,
    x2: 416.5,
    y2: 262,
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.5,
    y1: 257,
    x2: 421.5,
    y2: 330,
    id: "Stroke-4",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.56,
    y1: 335.44,
    x2: 418.44,
    y2: 335.56,
    id: "Stroke-5",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "418.44 335.68 418.56 335.56 418.56 335.32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 361,
    x2: 339.5,
    y2: 286,
    id: "Stroke-7",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "418.44 261.68 418.56 261.56 418.56 261.32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344,
    y1: 359,
    x2: 416,
    y2: 331,
    id: "Stroke-9",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418,
    y1: 336,
    x2: 344,
    y2: 364,
    id: "Stroke-10",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "418.68 332.8 418.68 332.44 418.44 332.2 418.32 332.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.14,
    y1: 364.5,
    x2: 341.86,
    y2: 364.5,
    id: "Stroke-12",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 262,
    x2: 344,
    y2: 290,
    id: "Stroke-13",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332,
    y1: 1,
    x2: 127,
    y2: 79,
    id: "Stroke-14",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5,
    y1: 84,
    x2: 360.5,
    y2: 75,
    id: "Stroke-16",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 129,
    x2: 360,
    y2: 85,
    id: "Stroke-17",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.8,
    y1: 198.56,
    x2: 391.2,
    y2: 198.44,
    id: "Stroke-18",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.5,
    y1: 384,
    x2: 270.5,
    y2: 313,
    id: "Stroke-19",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 383.86,
    x2: 272,
    y2: 383.14,
    id: "Stroke-20",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 201,
    x2: 389,
    y2: 199,
    id: "Stroke-22",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 328,
    x2: 271,
    y2: 384,
    id: "Stroke-23",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390,
    y1: 24,
    x2: 330,
    y2: 1,
    id: "Stroke-25",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187,
    y1: 102,
    x2: 390,
    y2: 24,
    id: "Stroke-26",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390,
    y1: 26,
    x2: 288,
    y2: 65,
    id: "Stroke-27",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5,
    y1: 194,
    x2: 360.5,
    y2: 190,
    id: "Stroke-28",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.8,
    y1: 233.38,
    x2: 477.2,
    y2: 233.62,
    id: "Stroke-29",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 313,
    x2: 185,
    y2: 280,
    id: "Stroke-30",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 478,
    y1: 231,
    x2: 392,
    y2: 198,
    id: "Stroke-31",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 310,
    x2: 336,
    y2: 285,
    id: "Stroke-32",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.5,
    y1: 310,
    x2: 270.5,
    y2: 312,
    id: "Stroke-33",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 277,
    x2: 271,
    y2: 310,
    id: "Stroke-34",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477,
    y1: 233,
    x2: 422,
    y2: 254,
    id: "Stroke-35",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5,
    y1: 191,
    x2: 360.5,
    y2: 185,
    id: "Stroke-36",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339,
    y1: 286,
    x2: 271,
    y2: 312,
    id: "Stroke-37",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392,
    y1: 198,
    x2: 384,
    y2: 201,
    id: "Stroke-38",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.5,
    y1: 305.5,
    x2: 475.5,
    y2: 305.5,
    id: "Stroke-39",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 238,
    x2: 360,
    y2: 194,
    id: "Stroke-40",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.5,
    y1: 198.44,
    x2: 391.5,
    y2: 198.56,
    id: "Stroke-41",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.5,
    y1: 102,
    x2: 186.5,
    y2: 277,
    id: "Stroke-42",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187,
    y1: 102,
    x2: 127,
    y2: 79,
    id: "Stroke-43",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.68,
    y1: 198.56,
    x2: 389.32,
    y2: 198.44,
    id: "Stroke-44",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391,
    y1: 198.08,
    x2: 389,
    y2: 198.92,
    id: "Stroke-45",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.5,
    y1: 198,
    x2: 391.5,
    y2: 23,
    id: "Stroke-46",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.5,
    y1: 304,
    x2: 475.5,
    y2: 234,
    id: "Stroke-47",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.5,
    y1: 280,
    x2: 184.5,
    y2: 278,
    id: "Stroke-48",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5,
    y1: 335,
    x2: 418.5,
    y2: 332,
    id: "Stroke-49",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 257,
    x2: 124.5,
    y2: 283,
    id: "Stroke-50",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.5,
    y1: 102,
    x2: 184.5,
    y2: 277,
    id: "Stroke-51",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.5,
    y1: 231,
    x2: 477.5,
    y2: 233,
    id: "Stroke-52",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.5,
    y1: 234,
    x2: 477.5,
    y2: 305,
    id: "Stroke-53",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187,
    y1: 102.14,
    x2: 185,
    y2: 102.86,
    id: "Stroke-54",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 79.86,
    x2: 127,
    y2: 79.14,
    id: "Stroke-55",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    y1: 262,
    x2: 416.5,
    y2: 331,
    id: "Stroke-56",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 257,
    x2: 124.5,
    y2: 179,
    id: "Stroke-57",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 79,
    x2: 185,
    y2: 102,
    id: "Stroke-58",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.44,
    y1: 364,
    x2: 344.56,
    y2: 290,
    id: "Stroke-59",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 178,
    x2: 124.5,
    y2: 79,
    id: "Stroke-60",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.5,
    y1: 26,
    x2: 389.5,
    y2: 199,
    id: "Stroke-61",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391,
    y1: 23.14,
    x2: 389,
    y2: 23.86,
    id: "Stroke-62",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-63",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "272 383 338.756393 357.299652 338.756393 363.643942 341.352025 364.813579 421.167688 334.404805 421.167688 326.021797 475 305"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239,
    y1: 257,
    x2: 185,
    y2: 278,
    id: "Stroke-65",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 253,
    x2: 478,
    y2: 231,
    id: "Stroke-66",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.5,
    y1: 198.5,
    x2: 389.5,
    y2: 198.5,
    id: "Stroke-67",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361,
    y1: 12,
    x2: 331,
    y2: 1,
    id: "Stroke-68",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418,
    y1: 331.98,
    x2: 416,
    y2: 331.02,
    id: "Stroke-69",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.5,
    y1: 26,
    x2: 389.5,
    y2: 24,
    id: "Stroke-70",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.5,
    y1: 65.5,
    x2: 287.5,
    y2: 65.5,
    id: "Stroke-71",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.5,
    y1: 198.5,
    x2: 391.5,
    y2: 198.5,
    id: "Stroke-72",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.5,
    y1: 23,
    x2: 391.5,
    y2: 198,
    id: "Stroke-73",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331,
    y1: 0,
    x2: 391,
    y2: 23,
    id: "Stroke-74",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.5,
    y1: 78.5,
    x2: 126.5,
    y2: 78.5,
    id: "Stroke-76",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 65,
    x2: 187,
    y2: 104,
    id: "Stroke-77",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.5,
    y1: 23.5,
    x2: 391.5,
    y2: 23.5,
    id: "Stroke-78",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.44,
    y1: 101.5,
    x2: 186.56,
    y2: 101.5,
    id: "Stroke-79",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.5,
    y1: 277.5,
    x2: 184.5,
    y2: 277.5,
    id: "Stroke-80",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342,
    y1: 364.98,
    x2: 344,
    y2: 364.02,
    id: "Stroke-81",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339,
    y1: 364.02,
    x2: 341,
    y2: 364.98,
    id: "Stroke-82",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 254,
    x2: 185,
    y2: 277,
    id: "Stroke-83",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.5,
    y1: 383.38,
    x2: 272.5,
    y2: 383.62,
    id: "Stroke-84",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.5,
    y1: 312,
    x2: 272.5,
    y2: 383,
    id: "Stroke-86",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 319,
    x2: 124.5,
    y2: 328,
    id: "Stroke-87",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5,
    y1: 261,
    x2: 418.5,
    y2: 258,
    id: "Stroke-88",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 280,
    x2: 125,
    y2: 257,
    id: "Stroke-89",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 283,
    x2: 124.5,
    y2: 319,
    id: "Stroke-90",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341,
    y1: 285,
    x2: 422,
    y2: 254,
    id: "Stroke-91",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 191,
    x2: 217,
    y2: 218,
    id: "Stroke-92",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 255,
    x2: 382,
    y2: 202,
    id: "Stroke-93",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.5,
    y1: 287,
    x2: 341.5,
    y2: 285,
    id: "Stroke-94",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 131,
    x2: 243,
    y2: 148,
    id: "Stroke-95",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422,
    y1: 256,
    x2: 341,
    y2: 287,
    id: "Stroke-96",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382,
    y1: 92.86,
    x2: 384,
    y2: 92.14,
    id: "Stroke-97",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.5,
    y1: 93,
    x2: 382.5,
    y2: 67,
    id: "Stroke-98",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339,
    y1: 287,
    x2: 262,
    y2: 257,
    id: "Stroke-99",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 258,
    x2: 217,
    y2: 248,
    id: "Stroke-100",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 204,
    x2: 243,
    y2: 258,
    id: "Stroke-101",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 202,
    x2: 383.5,
    y2: 204,
    id: "Stroke-102",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 118,
    x2: 384,
    y2: 64,
    id: "Stroke-103",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: 120,
    x2: 243.5,
    y2: 118,
    id: "Stroke-104",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 66,
    x2: 243,
    y2: 120,
    id: "Stroke-105",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 120,
    x2: 217,
    y2: 110,
    id: "Stroke-106",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 64,
    x2: 358,
    y2: 54,
    id: "Stroke-107",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 66,
    x2: 383.5,
    y2: 64,
    id: "Stroke-108",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 110,
    x2: 217.5,
    y2: 108,
    id: "Stroke-109",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358,
    y1: 54,
    x2: 288,
    y2: 81,
    id: "Stroke-110",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 176,
    x2: 383.5,
    y2: 202,
    id: "Stroke-111",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.5,
    y1: 202,
    x2: 382.5,
    y2: 176,
    id: "Stroke-112",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 255.14,
    x2: 243,
    y2: 255.86,
    id: "Stroke-113",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217,
    y1: 108,
    x2: 243,
    y2: 118,
    id: "Stroke-114",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 94,
    x2: 288,
    y2: 131,
    id: "Stroke-115",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 227,
    x2: 384,
    y2: 173,
    id: "Stroke-116",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 174,
    x2: 358,
    y2: 164,
    id: "Stroke-117",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.5,
    y1: 131.5,
    x2: 287.5,
    y2: 131.5,
    id: "Stroke-118",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 176,
    x2: 383.5,
    y2: 174,
    id: "Stroke-119",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 146,
    x2: 382,
    y2: 93,
    id: "Stroke-120",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: 230,
    x2: 243.5,
    y2: 228,
    id: "Stroke-121",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: 256,
    x2: 243.5,
    y2: 230,
    id: "Stroke-122",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.5,
    y1: 229,
    x2: 244.5,
    y2: 255,
    id: "Stroke-123",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217,
    y1: 246,
    x2: 243,
    y2: 256,
    id: "Stroke-124",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384,
    y1: 176,
    x2: 243,
    y2: 230,
    id: "Stroke-125",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217,
    y1: 217,
    x2: 243,
    y2: 227,
    id: "Stroke-126",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.5,
    y1: 190.5,
    x2: 287.5,
    y2: 190.5,
    id: "Stroke-127",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 81,
    x2: 217,
    y2: 108,
    id: "Stroke-128",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: 256,
    x2: 243.5,
    y2: 258,
    id: "Stroke-129",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 255,
    x2: 342,
    y2: 285,
    id: "Stroke-130",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 220,
    x2: 217.5,
    y2: 218,
    id: "Stroke-131",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 220,
    x2: 217.5,
    y2: 246,
    id: "Stroke-132",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: 146,
    x2: 243.5,
    y2: 120,
    id: "Stroke-133",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.5,
    y1: 119,
    x2: 244.5,
    y2: 145,
    id: "Stroke-134",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 230,
    x2: 217,
    y2: 220,
    id: "Stroke-135",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.5,
    y1: 80.5,
    x2: 287.5,
    y2: 80.5,
    id: "Stroke-136",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358,
    y1: 164,
    x2: 288,
    y2: 191,
    id: "Stroke-137",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 248,
    x2: 217.5,
    y2: 246,
    id: "Stroke-138",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382,
    y1: 202.86,
    x2: 384,
    y2: 202.14,
    id: "Stroke-139",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 66,
    x2: 383.5,
    y2: 92,
    id: "Stroke-140",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 149,
    x2: 217,
    y2: 139,
    id: "Stroke-141",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: 146,
    x2: 243.5,
    y2: 148,
    id: "Stroke-142",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 139,
    x2: 217.5,
    y2: 137,
    id: "Stroke-143",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: 92,
    x2: 383.5,
    y2: 94,
    id: "Stroke-144",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 194,
    x2: 382,
    y2: 203,
    id: "Stroke-145",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 85,
    x2: 382,
    y2: 93,
    id: "Stroke-146",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 110,
    x2: 217.5,
    y2: 136,
    id: "Stroke-147",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 145.14,
    x2: 243,
    y2: 145.86,
    id: "Stroke-148",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217,
    y1: 136,
    x2: 243,
    y2: 146,
    id: "Stroke-149",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.5,
    y1: 256,
    x2: 422.5,
    y2: 254,
    id: "Stroke-150",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342,
    y1: 286.98,
    x2: 339,
    y2: 286.02,
    id: "Stroke-151",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.5,
    y1: 290,
    x2: 344.5,
    y2: 287,
    id: "Stroke-152",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417,
    y1: 261.98,
    x2: 419,
    y2: 261.02,
    id: "Stroke-153",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344,
    y1: 355,
    x2: 416,
    y2: 328,
    id: "Stroke-154",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-155",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "262 257 262 254.785597 342.377613 224 422 254.461538"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-174",
    transform: "translate(130.000000, 207.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6870951,17.3581604 C44.099372,18.5000436 43.8117793,19.6547776 43.044562,19.9374946 C42.2764347,20.2192938 41.319916,19.5216803 40.9076391,18.3797971 C40.4944521,17.2379139 40.7820448,16.0831799 41.5501721,15.8013807 C42.3173894,15.5186637 43.2748182,16.2162772 43.6870951,17.3581604 Z",
    id: "Stroke-156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2480612,16.5406675 L44.6678226,15.9963454 C44.6678226,15.9963454 45.3613214,16.178092 45.4869157,16.7673919 C45.61251,17.3566917 45.2684909,17.7770957 45.2684909,17.7770957 L43.9288186,18.309485",
    id: "Stroke-158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3947916,16.0515119 C44.3947916,16.0515119 44.5959244,15.5741974 44.9954599,15.6659886 C45.3949953,15.7577799 45.735374,16.0873105 45.8882714,16.4755875 C46.0411687,16.8629466 46.0393485,17.4439852 45.8691592,17.7588292 C45.6944193,18.0828523 45.43686,17.9791282 45.3804336,17.9791282 C45.3230971,17.9791282 45.1592785,17.8689787 45.1592785,17.8689787",
    id: "Stroke-160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3714013,9.49761639 C23.7836781,10.6394996 23.4960854,11.7942336 22.7288682,12.0769506 C21.9607409,12.3587498 21.0042221,11.6611362 20.5919452,10.519253 C20.1787583,9.37736985 20.466351,8.22263587 21.2344783,7.94083672 C22.0016955,7.65811966 22.9591244,8.35573319 23.3714013,9.49761639 Z",
    id: "Stroke-162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9323673,8.68012348 L24.3521288,8.13580135 C24.3521288,8.13580135 25.0456276,8.31754803 25.1712219,8.90684788 C25.2968162,9.49614773 24.9527971,9.91655167 24.9527971,9.91655167 L23.6131247,10.4489409",
    id: "Stroke-164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0790977,8.19105968 C24.0790977,8.19105968 24.2802306,7.71374516 24.679766,7.80553642 C25.0793014,7.89732767 25.4196801,8.22685827 25.5725775,8.61513527 C25.7254749,9.00249437 25.7236547,9.583533 25.5534653,9.898377 C25.3787255,10.2224001 25.1211662,10.118676 25.0647398,10.118676 C25.0074033,10.118676 24.8435846,10.0085265 24.8435846,10.0085265",
    id: "Stroke-166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96824647,1.70380462 C3.38052334,2.84568781 3.09293064,4.00042178 2.32571341,4.28313885 C1.55758608,4.56493799 0.601067324,3.86732447 0.188790449,2.72544127 C-0.224396529,1.58355807 0.0631961696,0.428824102 0.831323504,0.147024953 C1.59854073,-0.135692109 2.55596959,0.561921419 2.96824647,1.70380462 Z",
    id: "Stroke-168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52921255,0.88631171 L3.94897397,0.341989576 C3.94897397,0.341989576 4.64247282,0.523736258 4.7680671,1.11303611 C4.89366138,1.70233596 4.54964227,2.1227399 4.54964227,2.1227399 L3.20996995,2.65512917",
    id: "Stroke-170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67594293,0.39724791 C3.67594293,0.39724791 3.8770758,-0.0800666091 4.27661122,0.0117246446 C4.67614665,0.103515898 5.01652535,0.433046499 5.16942273,0.821323503 C5.32232012,1.20868259 5.32049991,1.78972123 5.15031056,2.10456523 C4.97557069,2.42858836 4.71801141,2.32486424 4.66158499,2.32486424 C4.60424848,2.32486424 4.44042985,2.21471473 4.44042985,2.21471473",
    id: "Stroke-172"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 223,
    x2: 125,
    y2: 178,
    id: "Stroke-175",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-176",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6 226 6 225.571429 6.10526316 225.142857 6.21052632 224.714286 6.42105263 224.392857 6.52631579 224.071429 6.73684211 223.857143 6.84210526 223.75 6.94736842 223.642857 7.47368421 223.321429 8 223"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 233,
    x2: 5.5,
    y2: 226,
    id: "Stroke-177",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 235.14,
    x2: 2,
    y2: 235.86,
    id: "Stroke-178",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-183",
    transform: "translate(0.000000, 235.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 36.8734734,
    x2: 0.434782609,
    y2: 36.222765,
    id: "Stroke-179"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.434782609,
    y1: 0,
    x2: 0.434782609,
    y2: 36.222765,
    id: "Stroke-181"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 235.14,
    x2: 2,
    y2: 235.86,
    id: "Stroke-184",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 272,
    x2: 2.5,
    y2: 236,
    id: "Stroke-185",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 280,
    x2: 4,
    y2: 235,
    id: "Stroke-186",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 269,
    x2: 10,
    y2: 226,
    id: "Stroke-187",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 236,
    x2: 125,
    y2: 283,
    id: "Stroke-188",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 319,
    x2: 2,
    y2: 272,
    id: "Stroke-189",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 234.86,
    x2: 6,
    y2: 234.14,
    id: "Stroke-191",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 233,
    x2: 0,
    y2: 235,
    id: "Fill-192",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 233,
    x2: 0,
    y2: 235,
    id: "Stroke-193",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 233,
    x2: 5.5,
    y2: 236,
    id: "Stroke-195",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-246",
    transform: "translate(476.000000, 282.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42345847,4.90567536 C3.42345847,4.39249238 3.73460092,3.70146496 4.2623841,3.49619176",
    id: "Stroke-196",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.31786131,
    y1: 3.08706106,
    x2: 7.61799747,
    y2: 2.19518443,
    id: "Stroke-198",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.26265156,
    y1: 3.49619176,
    x2: 5.31821792,
    y2: 3.08741498,
    id: "Stroke-200",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.48310154,
    y1: 19.4475114,
    x2: 2.17077579,
    y2: 18.9387524,
    id: "Stroke-202",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77427381,23.3161147 C3.5513924,23.2302893 3.48274493,22.9675042 3.48274493,22.7657702",
    id: "Stroke-204",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.48310154,
    y1: 22.7656817,
    x2: 3.48310154,
    y2: 7.90107132,
    id: "Stroke-206",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40559554,4.83382974 C9.47513454,4.8055162 9.5535888,4.79843781 9.66413798,4.84090813",
    id: "Stroke-208",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 21.8242564,
    x2: 3.66149582,
    y2: 23.247012,
    id: "Stroke-210",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.17095409,
    y1: 16.1701302,
    x2: 3.42354762,
    y2: 16.6558845,
    id: "Stroke-212",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.64884426,
    y1: 2.19429963,
    x2: 1.990331,
    y2: 0,
    id: "Stroke-214",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61835408,2.19500747 C7.62816086,2.19058348 7.63796765,2.18969868 7.64866595,2.19412268",
    id: "Stroke-216",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.08247423,
    y1: 22.9975874,
    x2: 4.08247423,
    y2: 8.13386174,
    id: "Stroke-218",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68184692,7.1271383 C4.3056231,7.27401481 4.08274168,7.76773223 4.08274168,8.1340387",
    id: "Stroke-220",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.68184692,
    y1: 7.1271383,
    x2: 9.9552211,
    y2: 5.08236957,
    id: "Stroke-222",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08247423,22.9975874 C4.08247423,23.2002062 4.1511217,23.4629912 4.37400311,23.5488167",
    id: "Stroke-224",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.40559554,
    y1: 4.83382974,
    x2: 5.11557414,
    y2: 3.16952425,
    id: "Stroke-226",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2629758,5.07307919 C10.1524266,5.03060887 10.061491,5.04122645 9.95450788,5.08281197",
    id: "Stroke-228",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2629758,
    y1: 5.07307919,
    x2: 9.66387052,
    y2: 4.84126205,
    id: "Stroke-230",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3736465,23.5487282 C4.48419568,23.5920833 4.5751313,23.5805809 4.68211437,23.5389954",
    id: "Stroke-232",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.77427381,
    y1: 23.3161147,
    x2: 4.37337904,
    y2: 23.5488167,
    id: "Stroke-234",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5542372,5.62422001 C10.5542372,5.42248601 10.4864812,5.15970094 10.2627083,5.07299071",
    id: "Stroke-236",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5542372,
    y1: 5.62422001,
    x2: 10.5542372,
    y2: 20.4888304,
    id: "Stroke-238",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95486449,21.4946691 C10.3319798,21.3486774 10.5539697,20.8540752 10.5539697,20.4886535",
    id: "Stroke-240",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.95486449,
    y1: 21.4946691,
    x2: 4.68149031,
    y2: 23.5394378,
    id: "Stroke-242",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.48310154,
    y1: 7.90142524,
    x2: 3.42336932,
    y2: 4.9054984,
    id: "Stroke-244",
    stroke: "#2E3030",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 178,
    x2: 158,
    y2: 176,
    id: "Stroke-247",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151,
    y1: 173,
    x2: 152,
    y2: 177,
    id: "Stroke-248",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 180,
    x2: 151,
    y2: 181,
    id: "Stroke-249",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 181,
    x2: 158,
    y2: 184,
    id: "Stroke-250",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-255",
    transform: "translate(151.000000, 172.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.544719309,9.58035999 L6.85756501,11.9206039 C6.85756501,11.9206039 7.4376694,12.0780783 7.67626072,11.9494742 C7.91485205,11.8208702 7.94572857,11.6152787 7.94572857,11.6152787 L8,3.27088731 C8,3.27088731 8.00373901,2.95681345 7.76982595,2.71797734 C7.53497724,2.48001608 7.43111984,2.41965091 7.43111984,2.41965091 L0.925529773,0.0137926408 C0.925529773,0.0137926408 0.613021923,-0.047447388 0.326712336,0.0881555328 C0.0413384013,0.222883596 0.000169702542,0.421476261 0.000169702542,0.421476261 L0.000169702542,8.96970942 C0.000169702542,8.96970942 -0.0129294289,9.13943178 0.191042761,9.34064902 C0.39501495,9.54274111 0.544719309,9.58035999 0.544719309,9.58035999 Z",
    id: "Stroke-251",
    stroke: "#000000",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89402341,4.69550535 L3.48369658,5.20467245 L3.86450704,5.471504 L3.91877487,5.71296469 L3.91877487,8.20543386 C3.91877487,8.20543386 3.93374531,8.33753735 3.74661486,8.35940879 C3.48556788,8.38915394 3.4284931,8.30866705 3.4284931,8.30866705 L1.7415121,7.74875821 C1.7415121,7.74875821 1.62361991,7.7470085 1.48233642,7.58078556 C1.41496946,7.50204838 1.41496946,7.23959112 1.41496946,7.23959112 L1.41496946,4.86697743 C1.41496946,4.86697743 1.41496946,4.74887166 1.52444078,4.69550535 C1.63297644,4.64213904 1.89402341,4.69550535 1.89402341,4.69550535 Z",
    id: "Stroke-253",
    stroke: "#231F20",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketStudioLite);
export default __webpack_public_path__ + "static/media/pocket_studio_lite.2095c0d1531e9ad596573bb154e04bf9.svg";
export { ForwardRef as ReactComponent };